import type { Addresses } from 'api/types/addresses.types';
import type { FC } from 'react';
import React, { createContext, useMemo } from 'react';

const ContextValue = {};

export const AddressSheetContext = createContext(ContextValue);

export interface AddressSheetContextProviderProps {
  children: React.ReactNode;
  toggleSheet?: () => void;
  onEdit?: (address?: Addresses.Address) => void; // Updated prop type to accept an optional Address argument
  onContinue?: () => void;
}

const AddressSheetContextProvider: FC<AddressSheetContextProviderProps> = ({ children, toggleSheet, onEdit, onContinue }) => {
  const contextValue = useMemo(
    () => ({
      toggleSheet: toggleSheet!!,
      onEdit: onEdit!!,
      onContinue: onContinue!!,
    }),
    [toggleSheet, onEdit, onContinue]
  );

  return <AddressSheetContext.Provider value={contextValue}>{children}</AddressSheetContext.Provider>;
};

export default AddressSheetContextProvider;
